"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInviteState = exports.default = exports.cssAnchorName = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _GroupActionButtons = _interopRequireDefault(require("./GroupActionButtons"));

var _GroupJoinButton = _interopRequireDefault(require("./GroupJoinButton"));

var _GroupMembersWidget = _interopRequireDefault(require("./GroupMembersWidget"));

var _message = _interopRequireDefault(require("@insided/deprecated-preact-components/design-system-components/message"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _GroupJoin = _interopRequireDefault(require("@insided/deprecated-preact-components/groups-destination/GroupJoin"));

var _utils = require("./utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var cssAnchorName = 'group-statistics';
exports.cssAnchorName = cssAnchorName;

var getInviteState = function getInviteState(inviteStatus) {
  switch (inviteStatus) {
    case 'ok':
      return {
        type: 'success',
        message: 'groups.invite.joined'
      };

    case 'fail:invalid-invite':
      return {
        type: 'error',
        message: 'groups.invite.invalid_link'
      };

    case 'fail:invalid-user-role':
      return {
        type: 'error',
        message: 'groups.invite.invalid_role'
      };

    default:
      return null;
  }
};

exports.getInviteState = getInviteState;

var GroupStatistics = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupStatistics, _Component);

  var _super = _createSuper(GroupStatistics);

  function GroupStatistics() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupStatistics);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      invite: getInviteState(_this.props.inviteStatus),
      membersCount: null
    });
    return _this;
  }

  (0, _createClass2.default)(GroupStatistics, [{
    key: "render",
    value: function render() {
      var _this2 = this,
          _this$props$group,
          _this$props$group2,
          _this$props$group$cat,
          _this$props$group3,
          _this$props$group3$ca,
          _this$props$group3$ca2,
          _this$props$group4;

      var _this$props = this.props,
          canSee = _this$props.canSee,
          csrfToken = _this$props.csrfToken,
          group = _this$props.group,
          _this$props$featuredT = _this$props.featuredTopics,
          featuredTopics = _this$props$featuredT === void 0 ? [] : _this$props$featuredT,
          isCurrentUserModerator = _this$props.isCurrentUserModerator,
          isCurrentUserMember = _this$props.isCurrentUserMember;
      var _this$state = this.state,
          invite = _this$state.invite,
          membersCount = _this$state.membersCount;
      return (0, _preact.h)("div", null, invite !== null ? (0, _preact.h)(_message.default, {
        variant: invite.type,
        onDismiss: function onDismiss() {
          return _this2.setState({
            invite: null
          });
        },
        timer: invite.type !== 'error' ? 5000 : undefined
      }, (0, _preact.h)(_phrase.default, {
        p: invite.message,
        count: {
          g: (group === null || group === void 0 ? void 0 : group.name) || ''
        }
      })) : null, this.props.inviteStatus === 'fail:guest-user' ? (0, _preact.h)(_GroupJoin.default, {
        groupTitle: this.props.group.name,
        groupId: this.props.group.id,
        token: this.props.inviteToken
      }) : null, canSee && (0, _preact.h)("div", {
        className: "col"
      }, (0, _preact.h)("div", {
        className: "group-details-page_members-count"
      }, (0, _preact.h)(_GroupMembersWidget.default, {
        group: group,
        membersCount: membersCount,
        onLoadMembers: function onLoadMembers(total) {
          _this2.setState({
            membersCount: total
          });
        }
      })), (0, _preact.h)("div", {
        className: "group-details-page_action-buttons"
      }, !isCurrentUserMember ? (0, _preact.h)(_GroupJoinButton.default, {
        groupId: group.id,
        csrfToken: csrfToken,
        isPublicGroup: ((_this$props$group = this.props.group) === null || _this$props$group === void 0 ? void 0 : _this$props$group.visibility) === _utils.GroupVisibility.Public,
        isPrivateGroup: ((_this$props$group2 = this.props.group) === null || _this$props$group2 === void 0 ? void 0 : _this$props$group2.visibility) === _utils.GroupVisibility.Private
      }) : null, isCurrentUserMember || isCurrentUserModerator ? (0, _preact.h)(_GroupActionButtons.default, {
        isCurrentUserMember: isCurrentUserMember,
        isCurrentUserModerator: isCurrentUserModerator,
        groupId: group.id,
        curatedContentTitle: (_this$props$group$cat = (_this$props$group3 = this.props.group) === null || _this$props$group3 === void 0 ? void 0 : (_this$props$group3$ca = _this$props$group3.category) === null || _this$props$group3$ca === void 0 ? void 0 : (_this$props$group3$ca2 = _this$props$group3$ca.curatedContent) === null || _this$props$group3$ca2 === void 0 ? void 0 : _this$props$group3$ca2.title) !== null && _this$props$group$cat !== void 0 ? _this$props$group$cat : '',
        curatedContentTopics: featuredTopics,
        communityLocale: this.props.communityLocale,
        isHiddenGroup: ((_this$props$group4 = this.props.group) === null || _this$props$group4 === void 0 ? void 0 : _this$props$group4.visibility) === _utils.GroupVisibility.Hidden,
        csrfToken: csrfToken,
        onAddMembers: function onAddMembers() {
          _this2.setState(function (_ref) {
            var membersCount = _ref.membersCount;
            return {
              membersCount: membersCount === null ? 1 : membersCount + 1
            };
          });
        }
      }) : null)));
    }
  }]);
  return GroupStatistics;
}(_preact.Component);

var _default = GroupStatistics;
exports.default = _default;